const dictionary = {
  pages: {
    userGate: {
      'document-title': 'User Account',
      'document-desc': ''
    },

    userAccount: { 'sidebar-heading-main': 'Account' },

    error: {
      401: {
        'document-title': 'Unauthorized',
        'document-desc': '',
        'heading-main': '401 - Unauthorized',
        'page-content': 'You are not allowed to access this page without logging in.'
      },

      404: {
        'document-title': 'Page not found',
        'document-desc': '',
        'heading-main': '404 - Not found',
        'page-content': 'The page content you were looking for could not be found.'
      },

      500: {
        'document-title': 'Error occurred',
        'document-desc': '',
        'heading-main': 'Something went wrong',
        'page-content': 'Try again later.'
      }
    },

    home: {
      'document-title': 'Home',
      'document-desc': '',
      'section-top-link-badminton': 'Badminton',
      'section-top-link-golf': 'Golf',
      'section-top-link-football': 'Football',
      'section-top-link-climbing': 'Climbing',
      'section-top-link-tennis': 'Tennis',
      'section-top-link-squash': 'Squash',
      'section-top-link-allSports': 'More...',
      'section-middle-heading-interests': 'Interests',
      'section-middle-heading-featured': 'Featured',
      'section-middle-heading-new': 'New',
      'section-middle-heading-popular': 'Popular',
      'section-middle-link-allSports': 'See all'
    },

    sports: {
      'document-title-default': 'Available sports',
      'document-desc-default': '',
      'heading-main-default': 'Sports',

      'document-title-sport': '{sportName}',
      'document-desc-sport': '',
      'heading-main-sport': '{sportName} opportunities',

      'document-title-search': 'Search results',
      'document-desc-search': '',
      'heading-main-search': 'Search results'
    }
  },

  views: {
    userGate: {
      login: {
        'heading-main': 'Login',
        'menu-item-register': 'Create account',
        'menu-item-resetPassword': 'Forgotten password',
        'menu-item-login': 'Back to login',
        'field-username-label': 'Email',
        'field-username-desc': 'Your email address',
        'field-password-label': 'Password',
        'field-password-desc': 'Your password',
        'field-remember-desc': 'Remember me',
        'button-submit-login': 'Login',
        'button-submit-resetPassword': 'Send reset link',
        'text-separator': 'or login with:',
        'button-facebook': 'Facebook',
        'message-success-resetLink': 'We just sent a password reset link to your email address',
        'message-error-mistake': 'Invalid email or password',
        'message-error-general': 'Unable to login'
      },

      logout: {
        'heading-main': 'Are you sure?',
        'text-description': 'Would you like to logout from your WannaSport account?',
        'button-submit': 'Logout',
        'button-cancel': 'Cancel'
      },

      register: {
        'heading-main': 'Register',
        'menu-item-login': 'I already have an account',
        'field-name-label': 'Name',
        'field-name-desc': 'Your full name',
        'field-password-label': 'Password',
        'field-password-desc': 'Your password',
        'field-passwordRepeat-label': 'Password confirmation',
        'field-passwordRepeat-desc': 'Repeat your password',
        'field-email-label': 'Email address',
        'field-email-desc': 'Your email address',
        'field-email-placeholder': 'example@email.com',
        'field-acceptTerms-desc': 'I accept the terms and conditions',
        'field-acceptTerms-error-empty': 'You need to consent our terms and conditions in order to proceed',
        'field-acceptCookies-desc': 'I accept the cookie policy',
        'button-submit': 'Register',
        'message-success': 'Successful registration'
      },

      changeEmail: {
        'heading-main': 'Your email update request',
        'text-description': 'You requested to change your current email address to',
        'status-success': 'Updated',
        'status-error': 'Did not update',
        'message-success': 'You email address updated successfully'
      },

      confirmEmail: {
        'heading-main': 'Your email confirmation',
        'text-description': 'You requested to confirm your email address',
        'status-success': 'Confirmed',
        'status-error': 'Not confirmed',
        'message-success': 'You email address is now confirmed'
      },

      resetPassword: {
        'heading-main': 'Reset your password',
        'field-newPassword-label': 'New password',
        'field-newPassword-desc': 'Pick the next one carefully',
        'field-passwordRepeat-label': 'Password repeat',
        'field-passwordRepeat-desc': 'Repeat your password',
        'button-submit': 'Save',
        'button-login': 'Go to the login page',
        'message-success': 'You have successfully reset your password'
      }
    }
  },

  overlays: {
    userGate: {
      'overlay-title-login': 'User gate - login dialog',
      'overlay-title-logout': 'User gate - logout dialog',
      'overlay-title-register': 'User gate - registration dialog',
      'button-trigger-login': 'Login',
      'button-trigger-logout': 'Logout',
      'button-trigger-register': 'Register',
      'button-closer': 'Cancel'
    },

    newPaymentMethod: {
      'overlay-title': 'Payment method creator dialog',
      'button-trigger': 'Add new',
      'button-closer': 'Cancel',
      'heading-main': 'Create new payment method'
    },

    paymentMethodDetails: {
      'overlay-title': 'Payment method details dialog',
      'button-trigger': 'Details...',
      'button-closer': 'Close',
      'heading-main': 'Payment method details',
      'term-title': 'Payment method',
      'term-default': 'Default',
      'term-cardholder': 'Name',
      'term-type': 'Card type',
      'term-expiration': 'Expiration',
      'button-setDefault': 'Set as default',
      'button-setDefault-title': 'Set this payment method as default',
      'button-delete': 'Delete payment method',
      'prompt-delete': 'Are you sure you would like to delete this payment method?',
      'icon-defaultPaymentMethod-title': 'This is the default payment method',
      'text-loading-setDefault': 'Updating the default payment method',
      'text-loading-delete': 'Deleting your payment method',
      'message-success-setDefault': 'Default payment method updated successfully',
      'message-success-delete': 'Your payment method is deleted successfully'
    },

    subscriptionDetails: {
      'overlay-title': 'Subscription details dialog',
      'button-trigger': 'Details...',
      'button-closer': 'Close',
      'tab-title': 'Details of your subscription',
      'tab-info-title': 'Subscription info',
      'tab-transactions-title': 'Billing history',

      infoPanel: {
        'term-reference': 'Reference number',
        'term-status': 'Status',
        'term-created': 'Created',
        'term-updated': 'Updated',
        'term-price': 'Monthly price',
        'term-period': 'Period',
        'term-until': 'Paid until',
        'term-billing': 'Next billing',
        'term-discountAmount': 'Discount',
        'term-discountExpiration': 'Discount expiry',
        'term-payment': 'Payment method',
        'term-termination': 'Cancelled from',
        'text-termination-cancel': 'Are you sure you would like to cancel your subscription?',
        'text-termination-regret':
          'You have the option to cancel your subscription. Do you want to use your right of withdrawal?',
        'text-loading-changePaymentMethod': 'Changing the payment method',
        'text-loading-terminateSubscription': 'Ending your subscription',
        'field-didRegret-description': 'I want to use the right of withdrawal',
        'button-changePaymentMethod-title': 'Change payment method',
        'button-terminate-open': 'Cancel subscription',
        'button-terminate-close': 'Back',
        'button-terminate-cancel': 'Cancel subscription',
        'button-terminate-regret': 'Regret subscription',
        'message-success-changePaymentMethod': 'Payment method updated successfully',
        'message-success-cancelSubscription': 'Your subscription is cancelled successfully',
        'message-success-regretSubscription': 'Your subscription was regretted successfully'
      },

      transactionsPanel: {
        'heading-main': 'Billing history',
        'text-noResults': 'No charges so far',
        'column-date': 'Billing date',
        'column-price': 'Charged'
      }
    },

    purchaseDetails: {
      'overlay-title': 'Purchase details dialog',
      'button-trigger': 'Details...',
      'button-closer': 'Close',
      'tab-title': 'Details of your purchase',
      'tab-participants-title': 'Participants',
      'tab-transactions-title': 'Transactions',

      participantsPanel: {
        'heading-main': 'Booking participants',
        'column-name': 'Participant',
        'column-type': 'Role',
        'column-status': 'Status',
        'text-name-you': 'You',
        'text-tag-membershipped': 'Multipass',
        'text-type-undefined': 'None',
        'text-type-organizer': 'Organizer',
        'text-type-player': 'Player',
        'text-type-spectator': 'Spectator',
        'text-status-accepted': 'Accepted',
        'text-status-pending': 'Pending',
        'text-status-rejected': 'Rejected',
        'text-status-cancelled': 'Cancelled',
        'text-noResults': 'No participants'
      },

      transactionsPanel: {
        'heading-main': 'Purchase transactions',
        'column-date': 'Date',
        'column-status': 'Status',
        'column-price': 'Amount',
        'column-paymentMethod': 'Payment method',
        'text-transactionStatus-authorized': 'Authorized',
        'text-transactionStatus-refund': 'Refunded',
        'text-transactionStatus-settled': 'Settled',
        'text-transactionStatus-failed': 'Failed'
      }
    },

    friendInvitation: {
      'overlay-title': 'Friend invitation dialog',
      'heading-main': 'Invite your friend',
      'field-inviteeEmail-label': 'Invitee',
      'field-inviteeEmail-desc': "Your friend's email address",
      'button-trigger': 'Invite',
      'button-submit': 'Send invitation',
      'button-closer': 'Close',
      'message-success': "Your WannaSport invitation is sent to your friend's email address ({inviteeEmail})"
    },

    emailUpdateRequest: {
      'overlay-title': 'Email change request dialog',
      'heading-main': 'Update your email',
      'text-description':
        'Request your new email, then follow the instructions sent to your old email',
      'field-newEmail-label': 'New email address',
      'field-newEmail-desc': 'Your new email address',
      'field-confirmEmail-label': 'Email address confirmation',
      'field-confirmEmail-desc': 'Repeat your new email address',
      'button-submit': 'Request',
      'button-closer': 'Cancel',
      'message-success':
        'We have sent an email with further instructions to your old email address ({oldEmailAddress})'
    },

    voucherRedeeming: {
      'overlay-title': 'Voucher redeeming dialog',
      'heading-main': 'Redeem a voucher',
      'field-voucherCode-label': 'Voucher code',
      'field-voucherCode-desc': 'Voucher code',
      'button-trigger': 'Redeem',
      'button-submit': 'Redeem',
      'button-closer': 'Close',
      'message-success': 'Voucher redeemed successfully',
      'message-error':
        'Voucher is invalid or already used. For questions contact WannaSport Support'
    }
  },

  elements: {
    paymentMethodSelector: {
      'heading-main': 'Select payment method',
      'option-paymentMethod-title': 'Your payment method: {Name}',
      'button-submit': 'Save'
    },

    newCreditCard: {
      'field-name-label': 'Card name',
      'field-name-desc': 'A custom name for your saved card',
      'field-cardholder-label': 'Cardholder name',
      'field-cardholder-desc': 'The full name of the cardholder',
      'button-submit': 'Save new card',
      'loader-text': 'Checking your new credit card details',
      'message-success': 'Payment method created successfully'
    },

    editableArea: {
      'button-edit': 'Edit',
      'button-edit-title': 'Edit {ariaEditorName}',
      'button-closer': 'Cancel',
      'button-closer-title': 'Cancel changes',
      'button-submit': 'Save',
      'button-submit-title': 'Save changes'
    },

    customDayPicker: {
      'controller-button-month-next-title': 'Next month',
      'controller-button-month-prev-title': 'Previous month',
      'navbar-button-month-prev-title': 'Go to previous month ({monthNamePrev})',
      'navbar-button-month-next-title': 'Go to previous year ({yearPrev})',
      'navbar-button-year-prev-title': 'Go to next month ({monthNameNext})',
      'navbar-button-year-next-title': 'Go to next year ({yearNext})'
    },

    customInput: {
      'passwordMeter-title': 'Your password is {strength}',
      'passwordMeter-strength-min': 'Unacceptable',
      'passwordMeter-strength-low': 'Very weak',
      'passwordMeter-strength-mid': 'Weak',
      'passwordMeter-strength-high': 'Good',
      'passwordMeter-strength-max': 'Strong',
      'input-date-button-dropdown-title': 'Toggle the date picker dropdown',
      'input-password-button-show-title': 'Uncover the provided password',
      'input-password-button-hide-title': 'Hide the provided password',
      'input-select-noOptions-text': 'No options available',
      'input-select-createOption-text': 'Add "{userInput}"',
      'input-selectAsync-loading-text': 'Loading...',
      'input-selectAsync-noOptions-text': 'No options available'
    },

    menu: { 'button-toggler-title': 'Toggle menu' },

    loader: { 'text-loading': 'Loading' },

    hugeStatusIndicator: {
      'text-pending': 'Pending',
      'text-success': 'Success',
      'text-error': 'Error'
    },

    siteLogo: {
      'link-homePage-title': 'Go to the home page',
      'image-logo-alt': 'WannaSport logo',
      'image-logotype-alt': 'WannaSport text'
    },

    progressMeter: {
      'progress-indicator-title': 'Progress indicator',
      'list-steps-title': 'Progress steps'
    }
  },

  lists: {
    systemMessages: {
      'list-title': 'System messages',
      'list-item-title': 'System message',
      'list-item-button-dismiss-title': 'Dismiss this message',
      'text-title-success': 'Success: {message}',
      'text-title-info': 'Information: {message}',
      'text-title-warning': 'Warning: {message}',
      'text-title-error': 'Error occurred: {message}'
    },

    productList: {
      'button-prev-title': 'Scroll backwards',
      'button-next-title': 'Scroll forwards'
    }
  },

  general: {
    messages: {
      'error-general': 'Something went wrong',
      'error-input-empty': 'The "{fieldName}" field must be filled',
      'error-input-format': 'The format of the {fieldName} field is invalid',
      'error-input-email-format': 'The provided email format is invalid',
      'error-input-password-short': 'This password is too short - it has to be at least {minLength} characters',
      'error-input-password-weak': 'This password is too weak and can easily be guessed by attackers',
      'error-input-password-missing-uppercase': 'Your password has to contain at least 1 uppercase character',
      'error-input-password-missing-lowercase': 'Your password has to contain at least 1 lowercase character',
      'error-input-password-missing-digit': 'Your password has to contain at least 1 digit',
      'error-input-unmatch':
        "The input value of {thisFieldName} field does not match with {comparedFieldName}'s",
      'error-input-long': 'This value is too long - only {maxLength} characters are allowed',
      'warning-browser-outdated':
      'Your browser or its version is outdated and we no longer support it, therefore you might notice'
      + 'unexpected behaviour or errors. Please update to a modern browser for more security and better overall'
      + 'experience.',
      'prompt-leavingDirtyForm':
      'You have already filled some of the inputs whose data will be lost if you abandon the form. '
      + 'Are you sure you want to proceed?'
    },

    dates: {
      'month-1': 'January',
      'month-2': 'February',
      'month-3': 'March',
      'month-4': 'April',
      'month-5': 'May',
      'month-6': 'June',
      'month-7': 'July',
      'month-8': 'August',
      'month-9': 'September',
      'month-10': 'October',
      'month-11': 'November',
      'month-12': 'December',
      'day-1': 'Monday',
      'day-2': 'Tuesday',
      'day-3': 'Wednesday',
      'day-4': 'Thursday',
      'day-5': 'Friday',
      'day-6': 'Saturday',
      'day-7': 'Sunday'
    },

    units: {
      'piece-short': 'pcs.'
    }
  }
};

export default dictionary;